import React from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
export default function PricingCard({ mode, price, description, features }) {
  const navigate = useNavigate();
  return (
    <div
      className={
        mode === "Visionary"
          ? "pricingcard propricing"
          : "pricingcard gradientdiv"
      }
    >
      <p>{mode}</p>
      <h2>{price === 0 ? "Free" : `₹${price}/mo`}</h2>
      <div className="pricecardcontent">
        <p>{description}</p>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>
              <FaCheck className="reacttick" /> {feature}
            </li>
          ))}
        </ul>
        <button
          onClick={() => {
            navigate("/profile?page=membership");
          }}
        >
          {price === 0 ? "Start For Free" : "Start Now"}{" "}
        </button>
      </div>
    </div>
  );
}
